import DatePickerDialog from "@/components/DatePickerDialog/DatePickerDialog.vue";
import FeaturesService from "@/services/server/FeaturesService";
import RolesService from "@/services/server/RolesService";


import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper"
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper";
import Utils from '@/scripts/Utils';
import Rules from "@/utils/Rules";
import FunctionSelector from './FeaturesSelector.vue';

export default {
  components: {
    DatePickerDialog,
    FunctionSelector
  },
  name: "Roles",

  data: () => ({
    featuresData: [],
    rolesData: [],
    alertData: [],
    usersData: [],
    sectorsData: [],
    unitsData: [],
    sectorsAttachAlert: [],
    unitsAttachAlert: [],
    usersAttachWhatsappAlert: [],
    featuresByRole: [],
    unitsByAlertData: [],
    selectedFeatures: [],
    headers: [
      { text: "Nome", value: "name" },
      { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
    ],
    desserts: [],
    modalRole: false,
    columnsToChoose: [{ value: "name", text: "Nome" }],
    listActions: [
      { value: "edit", title: "Editar" },
      { value: "delete", title: "Excluir" },
    ],
    month: Array(30).fill(1).map((value, index) => (index + 1)),
    endMonth: [],
    endWeek: [],
    menuStart: false,
    menuEnd: false,

    columnToSearch: "name",
    alerTypeSelected: null,
    modalTitle: "Adicionar Perfil",
    searchText: "",
    startDateDialog: false,
    startDatePicker: null,
    minStartDate: null,
    maxStartDate: null,
    avaregeDays: 30,
    percentageAverage: 100,
    consumptionType: null,
    pointsList: [],
    editedPointsList: {},
    editedItem: {
      name: '',
      deletedAt: null
    },
    loading: {
      usersList: false,
      modalRole: false,
      mainTable: false,
      unitsList: false,
      sectorList: false,
      buttonList: false,
    },
    validForm: true
  }),

  methods: {

    async selectAction(item, value) {
      switch (value) {
        case "edit":
          this.editRole(item)
          break;
        case "delete":
          this.editedItem = { ...item }
          const usersByIdRoleList = (await RolesService.getUsersByIdRole(this.editedItem.id_doc)).data.data
          usersByIdRoleList.length ? 
          showInfoSnackBar("Perfil vinculado a usuários mude o perfil dos usuários referentes antes de excluir."):
          showDeleteDialogAlert(`Deseja excluir o perfil "${item.name}"?`, this.deleteItemConfirm)
          break;
        default:
          break;
      }
    },
    async deleteItemConfirm() {
      this.loading.buttonList = true

      await RolesService.deleteRole(this.editedItem.id_doc)

      showSuccessSnackBar("Perfil deletado!")
      this.rolesData = this.rolesData.filter((role) => role.id_doc != this.editedItem.id_doc)
      this.closeRoleModal()
    },
    async editRole(item) {
      this.editedItem = { ...item }
      this.featuresByRole = (await RolesService.getRoleFeaturesByIdRole(this.editedItem.id_doc)).data.data
      this.selectedFeatures = this.featuresByRole.map(({ id_feature }) => id_feature)
      this.modalTitle = "Editar Perfil"
      this.modalRole = true
    },

    async save() {
      try {
        if ((this.$refs.form) && !this.$refs.form.validate()) return;
        this.loading.modalRole = true

        if (this.modalTitle === "Adicionar Perfil") {
          const response = await RolesService.createRole(this.editedItem, this.selectedFeatures)
          showSuccessSnackBar("Perfil criado!")
          this.rolesData.unshift(response.data.data)
        } else {
          const response = await RolesService.editRole(this.editedItem.id_doc, this.editedItem, this.selectedFeatures)
          showSuccessSnackBar("Perfil editado!")
          this.rolesData = this.rolesData.map((role) => role.id_doc === this.editedItem.id_doc ? response.data.data : role)
        }
        this.loading.modalRole = false
        this.closeRoleModal()
      } catch (error) {
        this.loading.modalRole = false
        console.error('Error save: ' + error)
      }
    },

    resetRoleForm() {
      this.featuresByRole = []
      this.selectedFeatures = []
      this.validForm = true
      this.editedItem = {
        name: '',
        deletedAt: null
      }
    },
    openCreateRoleModal() {
      this.resetRoleForm()
      this.modalTitle = "Adicionar Perfil"
      this.modalRole = true
    },
    closeRoleModal() {
      this.loading.buttonList = false
      this.modalRole = false
      this.sectorsAttachAlert = []
      this.unitsAttachAlert = []
      this.loading.modalRole = false
      this.resetRoleForm()
    },
  },
  computed: {
    filteredItems() {
      return this.rolesData.filter(i => 
        i[this.columnToSearch].toLowerCase().includes(this.searchText.toLowerCase())
      );
    },
    rulesRequired() {
      return Rules.required();
    },

  },
  watch: {

  },
  async mounted() {
    this.loading.mainTable = true
    this.rolesData = (await RolesService.getRoles()).data.data
    this.loading.mainTable = false
    this.featuresData = (await FeaturesService.getFeatures()).data.data
    this.featuresData = this.featuresData.map(
      (feature) => {
        let type_translated = feature.type
        if (feature.type == 'Buttons') type_translated = 'Botões'
        return {
          ...feature,
          type_translated: type_translated,
        }
      }
    )

  },
};
